export default "__VITE_ASSET__Bte1geve__"